// Helper to look up a locality by id from the static dataset and return its coordinates.
// Returns null if the locality has no coordinates.
import LOCALITIES from "@/data/israel-localities.json";

const BY_ID = new Map(LOCALITIES.map((l) => [l.id, l]));

export function findLocality(id) {
  if (id == null) return null;
  return BY_ID.get(Number(id)) || BY_ID.get(id) || null;
}

export function localityCoords(id) {
  const l = findLocality(id);
  if (l && typeof l.lat === "number" && typeof l.lng === "number") {
    return { lat: l.lat, lng: l.lng };
  }
  return null;
}

// Default fallback: geometric center of Israel
export const ISRAEL_CENTER = { lat: 31.5, lng: 34.9 };

export function localityName(id, lang) {
  const l = findLocality(id);
  if (!l) return null;
  if (lang === "ar") return l.ar || l.en || l.he;
  if (lang === "he") return l.he || l.en || l.ar;
  return l.en || l.he || l.ar;
}

// Detect test / demo data we should hide from the production feed.
const TEST_PATTERNS = [
  /^TEST\b/i,
  /^Mobile report\b/i,
  /^Mobile Smoke\b/i,
  /^Smoke\b/i,
  /\bplaywright\b/i,
  /\bSrchTerm\b/i,
];
export function isTestReport(r) {
  if (!r) return false;
  const title = String(r.title || "");
  const desc = String(r.description || "");
  const authorName = String(r.author?.name || "");
  return TEST_PATTERNS.some((p) => p.test(title) || p.test(desc) || p.test(authorName));
}

export function cleanReports(list) {
  return (list || []).filter((r) => !isTestReport(r));
}

// Same predicate also applies to community posts (content / author).
export function isTestPost(p) {
  if (!p) return false;
  const content = String(p.content || "");
  const authorName = String(p.author?.name || "");
  return TEST_PATTERNS.some((pat) => pat.test(content) || pat.test(authorName));
}

export function cleanPosts(list) {
  return (list || []).filter((p) => !isTestPost(p));
}
